module.exports = __webpack_public_path__ + "img/landlord-insurance.ecb25ba6.png";